import { render, staticRenderFns } from "./IconStarRounded.vue?vue&type=template&id=bae5848e&"
import script from "./IconStarRounded.vue?vue&type=script&lang=ts&"
export * from "./IconStarRounded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports